import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';

const ArabicSpans = (props) => {
  const { textAreaRef, setText, text } = props;

  const handleAddSpan = (span) => {
    const { selectionStart, selectionEnd } = textAreaRef.current;
    const newText = text.slice(0, selectionStart) + span + text.slice(selectionEnd);
    setText(newText);
  };

  const spans = [
    'ُ',
    'ِ',
    'َ',
    'ّ',
    'ْ',
    'ً',
    'ٍ',
    'ٌ',
    'ٰ',
    'ٓ',
    'ٔ',
    'ٕ',
    'ٖ',
    'ٗ',
    '٘',
    'ٙ',
    'ٚ'
  ];

  return (
    <div>
      <ButtonGroup
        size="xl"
        className="d-flex justify-content-center mb-2 text-center  arabic-spans"
        style={{ direction: 'rtl' }}>
        {spans.map((span, i) => (
          <Button onClick={() => handleAddSpan(span)} key={i}>
            <span className="arabic-span-button">{span}</span>
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default ArabicSpans;
